/**
 * Results per options
 */
export const NUMBER_OF_RESULTS_FOR_FAVOURITE_PLACES = 4;

/**
 * Nominatim geocode call values
 */
export const NOMINATIM_EMAIL = "devs@metatavu.fi";